export default __webpack_public_path__ + "static/media/telegram.2a584fb5.svg";